import React, { useEffect, useState } from "react";
import '../styles/Header.css';

export default function Header() {
    const [text, setText] = useState("Hi, my name is Rémy and I am an IT student");
    const [isNotVisible, setIsNotVisible] = useState(true);

    useEffect(() => {
        const originalText = "Hi 👋, my name is Rémy KINZELIN and I am an IT student";
        let newText = "";
        let i = 0;

        const interval = setInterval(() => {
            if (i < originalText.length) {
                newText += originalText[i];
                setText(newText);
                i++;
            } else {
                clearInterval(interval);
                setIsNotVisible(false);
            }
        }, 100); // Réglage de la vitesse de frappe

        return () => clearInterval(interval);
    }, []);

    return (
        <section id={'welcome-section'} className={'welcome-section'}>
            <div className="header">
                <div className="header__title">
                    <p>{text}</p>
                </div>
                <div className={`header__logo ${isNotVisible ? 'notVisible' : 'visible'}`}>
                    <img src={require('../video/memoji.gif')} alt="Programmer" />
                </div>
            </div>
        </section>
    );
}
